/* PETAVIS — tema etkileşimleri
   Bağımlılık yok. Dawn'ın kendi JS'ine dokunmaz. */
(function () {
  'use strict';

  /* --- mobil menü ------------------------------------------------------- */
  function initMobileNav() {
    var drawer = document.querySelector('[data-pv-mobile-nav]');
    var overlay = document.querySelector('[data-pv-overlay]');
    if (!drawer || !overlay) return;

    function open() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-pv-nav-open]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    document.querySelectorAll('[data-pv-nav-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* --- sekmeler --------------------------------------------------------- */
  function initTabs() {
    document.querySelectorAll('[data-pv-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      if (!tabs.length) return;

      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(tab);
        });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (next) {
            e.preventDefault();
            next.focus();
            select(next);
          }
        });
      });
    });
  }

  /* --- istek listesi (localStorage) ------------------------------------- */
  var WISH_KEY = 'petavis:wishlist';

  function readWish() {
    try {
      return JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeWish(list) {
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(list));
    } catch (e) {
      /* kota dolu olabilir, sessiz geç */
    }
    paintWishCount(list.length);
  }

  function paintWishCount(n) {
    document.querySelectorAll('[data-pv-wish-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function initWishlist() {
    var list = readWish();
    paintWishCount(list.length);

    document.querySelectorAll('[data-pv-wish]').forEach(function (btn) {
      var handle = btn.getAttribute('data-pv-wish');
      if (list.indexOf(handle) !== -1) btn.setAttribute('aria-pressed', 'true');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var cur = readWish();
        var at = cur.indexOf(handle);
        if (at === -1) {
          cur.push(handle);
          btn.setAttribute('aria-pressed', 'true');
        } else {
          cur.splice(at, 1);
          btn.setAttribute('aria-pressed', 'false');
        }
        writeWish(cur);
      });
    });
  }

  /* --- hızlı sepete ekle ------------------------------------------------ */
  function initQuickAdd() {
    document.querySelectorAll('[data-pv-quickadd]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-pv-quickadd');
        if (!id) return;
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            btn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('petavis:cart:added'));
            refreshCartCount();
            setTimeout(function () {
              btn.textContent = label;
              btn.disabled = false;
            }, 1600);
          })
          .catch(function () {
            btn.textContent = 'Try again';
            setTimeout(function () {
              btn.textContent = label;
              btn.disabled = false;
            }, 1600);
          });
      });
    });
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-pv-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* --- "load more" ------------------------------------------------------ */
  function initLoadMore() {
    document.querySelectorAll('[data-pv-loadmore]').forEach(function (btn) {
      var gridId = btn.getAttribute('data-pv-loadmore');
      var grid = document.getElementById(gridId);
      if (!grid) return;
      var step = parseInt(btn.getAttribute('data-pv-step') || '8', 10);

      btn.addEventListener('click', function () {
        var hidden = grid.querySelectorAll('[data-pv-hidden="true"]');
        Array.prototype.slice.call(hidden, 0, step).forEach(function (el) {
          el.removeAttribute('data-pv-hidden');
          el.hidden = false;
        });
        if (!grid.querySelectorAll('[data-pv-hidden="true"]').length) {
          btn.hidden = true;
        }
      });
    });
  }

  /* --- görünürlük animasyonu -------------------------------------------- */
  function revealAll() {
    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
  }

  function initReveal() {
    var items = document.querySelectorAll('.pv-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px 200px 0px', threshold: 0 }
    );

    items.forEach(function (el) {
      io.observe(el);
    });

    // Emniyet ağı: gözlemci herhangi bir sebeple ıskalarsa içerik
    // görünmez kalmasın. Animasyon bir bonus, şart değil.
    setTimeout(revealAll, 2500);
    window.addEventListener('load', function () {
      setTimeout(revealAll, 1200);
    });
  }

  /* --- destek widget'ı --------------------------------------------------- */
  function initSupport() {
    var root = document.querySelector('[data-pv-support]');
    if (!root || root.dataset.pvBound) return;
    root.dataset.pvBound = '1';

    var panel = root.querySelector('.pv-support__panel');
    var btns = root.querySelectorAll('[data-pv-support-toggle]');

    function toggle(force) {
      var open = typeof force === 'boolean' ? force : panel.hidden;
      panel.hidden = !open;
      root.classList.toggle('is-open', open);
      root.querySelector('.pv-support__btn').setAttribute('aria-expanded', String(open));
      if (open) {
        var f = panel.querySelector('textarea, a');
        if (f) f.focus();
      }
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () { toggle(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) toggle(false);
    });

    var form = root.querySelector('[data-pv-support-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.getAttribute('data-email');
        var msg = form.querySelector('textarea').value.trim();
        if (!msg || !email) return;
        // Gerçek gönderim: kullanıcının e-posta uygulamasını açar.
        window.location.href =
          'mailto:' + email +
          '?subject=' + encodeURIComponent('Support request — ' + (window.PV_SHOP_NAME || 'Petavis')) +
          '&body=' + encodeURIComponent(msg + '\n\n---\nPage: ' + window.location.href);
      });
    }
  }

  function boot() {
    initSupport();
    initMobileNav();
    initTabs();
    initWishlist();
    initQuickAdd();
    initLoadMore();
    initReveal();
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // tema editöründe bölüm yeniden yüklenince tekrar bağla
  document.addEventListener('shopify:section:load', boot);

  // Katalog motoru DOM'a kart bastığında wishlist/reveal'i yeniden bağlamak için.
  window.PVBoot = boot;
})();
